/* Glosar de termeni — căutare live, navigare A–Z, offset pentru header-ul sticky.
   Folosit de sections/glosar-termeni.liquid. */
(function () {
  var root = document.querySelector('[data-glo]');
  if (!root) return;

  var toolbar = root.querySelector('[data-glo-toolbar]');
  var input = root.querySelector('[data-glo-search]');
  var clearBtn = root.querySelector('[data-glo-clear]');
  var countEl = root.querySelector('[data-glo-count]');
  var emptyEl = root.querySelector('[data-glo-empty]');
  var groups = Array.prototype.slice.call(root.querySelectorAll('.glo-group'));
  var letterLinks = Array.prototype.slice.call(root.querySelectorAll('a.glo-letters__item'));

  // Fără diacritice și litere mici, ca „sterilizare” să găsească „Sterilizare” și „ș” = „s”
  function normalize(str) {
    return str.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  }

  function escapeHtml(str) {
    return str.replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  var terms = Array.prototype.slice.call(root.querySelectorAll('[data-glo-term]')).map(function (el) {
    var nameEl = el.querySelector('.glo-term__name');
    var name = nameEl.textContent;
    return {
      el: el,
      group: el.closest('.glo-group'),
      nameEl: nameEl,
      name: name,
      normName: normalize(name),
      normText: normalize(el.textContent)
    };
  });

  function setCount(n) {
    countEl.textContent = (countEl.getAttribute('data-template') || '[count]').replace('[count]', n);
  }

  // Marchează potrivirea în denumire; normalize() păstrează lungimea pentru literele românești
  function highlight(term, q) {
    var i = q ? term.normName.indexOf(q) : -1;
    if (i < 0 || term.normName.length !== term.name.length) {
      term.nameEl.textContent = term.name;
      return;
    }
    term.nameEl.innerHTML =
      escapeHtml(term.name.slice(0, i)) +
      '<mark>' + escapeHtml(term.name.slice(i, i + q.length)) + '</mark>' +
      escapeHtml(term.name.slice(i + q.length));
  }

  function filter() {
    var q = normalize(input.value.trim());
    var visible = 0;
    var lettersWithHits = {};

    terms.forEach(function (term) {
      var hit = !q || term.normText.indexOf(q) !== -1;
      term.el.hidden = !hit;
      highlight(term, hit ? q : '');
      if (hit) {
        visible++;
        lettersWithHits[term.group.getAttribute('data-letter')] = true;
      }
    });

    groups.forEach(function (g) {
      g.hidden = !lettersWithHits[g.getAttribute('data-letter')];
    });
    letterLinks.forEach(function (a) {
      a.classList.toggle('is-filtered-out', !lettersWithHits[a.getAttribute('data-letter')]);
    });

    clearBtn.hidden = !q;
    emptyEl.hidden = visible > 0;
    setCount(visible);
    updateActiveLetter();
  }

  var debounce;
  input.addEventListener('input', function () {
    clearTimeout(debounce);
    debounce = setTimeout(filter, 120);
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      input.value = '';
      filter();
    }
  });
  clearBtn.addEventListener('click', function () {
    input.value = '';
    filter();
    input.focus();
  });

  // Header-ul temei (sticky-header / sticky-header-mobile) acoperă bara de căutare la scroll,
  // așa că o poziționăm sub el și calculăm offset-ul pentru ancore.
  // Tema nu face sticky elementul <sticky-header>, ci secțiunea părinte
  // (.section-header-navigation / .section-header-mobile), așa că urcăm în arbore
  // până la primul element fixed/sticky și îi luăm marginea de jos.
  var headerSelectors = '.section-header-navigation, .section-header-mobile, sticky-header, sticky-header-mobile';
  function headerBottom() {
    var bottom = 0;
    var seen = [];
    Array.prototype.forEach.call(document.querySelectorAll(headerSelectors), function (el) {
      for (var node = el; node && node !== document.body; node = node.parentElement) {
        if (seen.indexOf(node) !== -1) break;
        seen.push(node);
        var pos = getComputedStyle(node).position;
        if (pos !== 'fixed' && pos !== 'sticky') continue;
        var rect = node.getBoundingClientRect();
        // Doar dacă e vizibil și lipit de marginea de sus (header-ul de desktop e ascuns pe mobil)
        if (rect.height > 0 && rect.top <= 1 && rect.bottom > 0) bottom = Math.max(bottom, rect.bottom);
        break;
      }
    });
    return bottom;
  }

  var ticking = false;
  var settle;
  function updateOffsets() {
    ticking = false;
    var top = Math.max(0, Math.round(headerBottom()));
    root.style.setProperty('--glo-header-offset', top + 'px');
    root.style.setProperty('--glo-scroll-offset', top + toolbar.offsetHeight + 16 + 'px');
    updateActiveLetter();
  }
  function requestUpdate() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(updateOffsets);
    }
    // Header-ul se micșorează animat după scrolled-past-header: re-măsurăm după animație
    clearTimeout(settle);
    settle = setTimeout(updateOffsets, 400);
  }
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);

  // Litera activă = ultimul grup vizibil al cărui început a trecut de bara sticky
  var activeLetter = null;
  function updateActiveLetter() {
    var limit = toolbar.getBoundingClientRect().bottom + 24;
    var current = null;
    for (var i = 0; i < groups.length; i++) {
      if (groups[i].hidden) continue;
      if (groups[i].getBoundingClientRect().top <= limit) current = groups[i].getAttribute('data-letter');
      else break;
    }
    if (current === activeLetter) return;
    activeLetter = current;
    letterLinks.forEach(function (a) {
      var on = a.getAttribute('data-letter') === current;
      a.classList.toggle('is-active', on);
      if (on) {
        a.setAttribute('aria-current', 'true');
        // Pe mobil bara de litere are scroll orizontal: ține litera activă în vizor
        var nav = a.parentElement;
        if (nav.scrollWidth > nav.clientWidth) {
          nav.scrollLeft = a.offsetLeft - nav.clientWidth / 2 + a.offsetWidth / 2;
        }
      } else {
        a.removeAttribute('aria-current');
      }
    });
  }

  // Scroll la literă/termen ținând cont de offset (scroll-margin-top acoperă și ancorele directe)
  function scrollToTarget(target) {
    updateOffsets();
    var offset = parseInt(getComputedStyle(root).getPropertyValue('--glo-scroll-offset'), 10) || 0;
    var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  root.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link || !root.contains(link)) return;
    var id = decodeURIComponent(link.getAttribute('href').slice(1));
    var target = document.getElementById(id);
    if (!target || !root.contains(target)) return;
    e.preventDefault();

    // Un termen ascuns de căutare trebuie să redevină vizibil
    if (target.hidden || (target.closest('.glo-group') || {}).hidden) {
      input.value = '';
      filter();
    }
    if (history.replaceState) history.replaceState(null, '', '#' + id);
    scrollToTarget(target);

    if (target.hasAttribute('data-glo-term')) {
      terms.forEach(function (t) { t.el.classList.remove('is-highlighted'); });
      target.classList.add('is-highlighted');
      setTimeout(function () { target.classList.remove('is-highlighted'); }, 2500);
    }
  });

  // Tipuri de produs biocid: tab-uri (fără JS toate grupele rămân vizibile, una sub alta)
  var tp = root.querySelector('[data-glo-tp]');
  if (tp) {
    var tablist = tp.querySelector('[data-glo-tabs]');
    var tabs = Array.prototype.slice.call(tp.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(tp.querySelectorAll('[data-glo-panel]'));

    var selectTab = function (tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        document.getElementById(t.getAttribute('aria-controls')).hidden = !on;
      });
      if (focus) tab.focus();
    };

    tablist.hidden = false;
    tp.classList.add('is-tabs');
    panels.forEach(function (p) { p.setAttribute('tabindex', '0'); });
    selectTab(tabs[0], false);

    tablist.addEventListener('click', function (e) {
      var tab = e.target.closest('[role="tab"]');
      if (tab) selectTab(tab, false);
    });
    tablist.addEventListener('keydown', function (e) {
      var i = tabs.indexOf(document.activeElement);
      if (i === -1) return;
      var next = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 }[e.key];
      if (next === undefined) return;
      e.preventDefault();
      selectTab(tabs[(next + tabs.length) % tabs.length], true);
    });
  }

  setCount(terms.length);
  updateOffsets();

  // Link direct către un termen (ex. /pages/glosar-de-termeni#virucid)
  if (location.hash) {
    var initial = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (initial && root.contains(initial)) {
      window.addEventListener('load', function () { scrollToTarget(initial); });
    }
  }
})();
